import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.363 7.327V5.153l-1.236 1.76-2.05-.68 1.293 1.76-1.27 1.76 2.03-.67 1.236 1.76V8.67l2.074-.68-2.077-.663zm8.56.68L9.377 13H5.473l4.55-4.993L5.473 3h3.904l4.546 5.007z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73l-1.854 2.64-3.076-1.021 1.94 2.641-1.905 2.64 3.045-1.005 1.855 2.639v-3.259l3.11-1.02-3.115-.995zm12.84 1.02l-6.819 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.82 7.51z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.09 21.98v-6.52l-3.708 5.28-6.153-2.04 3.88 5.281-3.81 5.28 6.09-2.01 3.71 5.279v-6.52l6.22-2.04-6.23-1.99zm25.68 2.04L28.13 39H16.42l13.65-14.98L16.42 9h11.712L41.77 24.02z",
    clipRule: "evenodd"
  }))
};
export var Converse = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});